/* @fflow */
import { fetchGraphql } from 'utils/ajax';

export let RELATED_ENTITIES_REQUEST = 'gdc/RELATED_ENTITIES_REQUEST';
export let RELATED_ENTITIES_SUCCESS = 'gdc/RELATED_ENTITIES_SUCCESS';
export let RELATED_ENTITIES_FAILURE = 'gdc/RELATED_ENTITIES_FAILURE';

function queryRelatedEntities({
  id, queries
}) {
  return {
    variables: { id },
    query: `
      query RelatedEntitiesQuery($id: String) {
        ${queries.join()}
      }
    `
  };
}

export function fetchRelatedEntities(selected) {
  return fetchGraphql(
    [{
      type: RELATED_ENTITIES_REQUEST,
      meta: { id: selected.id }
    }, {
      type: RELATED_ENTITIES_SUCCESS,
      meta: { id: selected.id }
    }, RELATED_ENTITIES_FAILURE],
    queryRelatedEntities(selected)
  );
}

export default function reducer(state = {
  isFetching: false,
  id: '',
  relatedEntities: {}
}, action) {
  switch (action.type) {
  case RELATED_ENTITIES_REQUEST:
    return {
      ...state,
      isFetching: true,
      id: action.meta.id,
    };
  case RELATED_ENTITIES_SUCCESS:
    return {
      ...state,
      isFetching: false,
      relatedEntities: action.meta.id === state.id
        ? action.payload.data
        : state.relatedEntities
    };
  case RELATED_ENTITIES_FAILURE:
    return {
      ...state,
      isFetching: false
    };
  default:
    return state;
  }
}
